import { render, staticRenderFns } from "./jinKongAnnouncement.vue?vue&type=template&id=36865b12&scoped=true&"
import script from "./jinKongAnnouncement.vue?vue&type=script&lang=js&"
export * from "./jinKongAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./jinKongAnnouncement.vue?vue&type=style&index=0&id=36865b12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36865b12",
  null
  
)

export default component.exports